import type { TColor } from '@Theme';
import OwnableTheme from '@Theme';
import type { FC } from 'react';
import React from 'react';
import type { StyleProp, TextStyle } from 'react-native';

import type { Size, Weight } from '../../Common/Text';
import { Text } from '../../Common/Text';

type IProductNameProps = {
  productName: string | null | undefined;
  weight?: Weight;
  size?: Size;
  color?: TColor;
  fontStyleOverride?: StyleProp<TextStyle>;
};

const ProductName: FC<IProductNameProps> = ({
  weight = 'regular',
  size = 's',
  productName,
  color = OwnableTheme.colors.persianIndigo,
  fontStyleOverride,
}) => {
  let renderName = 'Unnamed Product';

  if (productName) {
    const trimmed = productName.trim();
    if (trimmed.length) {
      renderName = trimmed;
    }
  }

  return (
    <Text
      size={size}
      weight={weight}
      gutterBottom={6}
      color={color}
      fontStyleOverride={fontStyleOverride}
    >
      {renderName}
    </Text>
  );
};

export default ProductName;
